export default __webpack_public_path__ + "static/blue-0810e846883159ef9f8c4347a8394210.png";